import React from 'react';
import AttachmentService from '../Services/AttachmentService';
import AuthService from '../Services/authService';
import ErrorMessage from './ErrorMessage';
import FigmaButton from './FigmaButton';
import Loading from './loading.js';
import fileHelper from '../Helpers/fileHelper';
import FigmaButtonRow from './FigmaButtonRow';
import ButtonColorsEnum from '../Enums/ButtonColorsEnum';
import ButtonTypeEnum from '../Enums/ButtonTypeEnum';
import IconPositionEnum from '../Enums/IconPositionEnum';
import AddNewAttachmentWindow from './AddNewAttachmentWindow';
import '../Css/AttachmentsComponent.css';

class AttachmentsComponent extends React.Component {
  // EntitiTypesIds and EntityTypes:
  // 1	User
  // 2	Role
  // 3	Office
  // 4	Attachment
  // 5	Comment
  // 6	Case
  // 7	Client
  // 8	Lead
  // 9	Address
  // 10	Country
  // 11	Contact
  // 12	Opportunity
  // 13	RFQ
  // 14	Service
  // 15	Pricing
  // 16	Tier
  // 17	Currency
  // 18	PricingDetail
  // 19	LeadImport
  // 24	Location
  // 25	Assignment
  // 26	Invoice
  // 27	Evaluator
  // 28	ClientInvoice
  // 29	ClientFee
  // 30	AssignmentPayment
  // 33	ClientPayment
  // 34	ClientLine
  // 35	Survey
  // 36	CreditMemo
  // 37	LineItemCredit
  // 38	Export
  // 41	ExportPayment
  // 42	IOBInvoice
  // 43	IOBLineItem
  // 44	Check
  // 45	CheckRec
  // 46	ARTransaction
  // 47	APTransaction
  // 48	AssignmentPaymentRefund
  // 49	ClientPaymentRefund
  // 50	ExportBatch
  // 51	ExportBatchFile
  // 53	ReportTemplate
  // 57	ImportEvent
  // 58	Editor
  // 59	Event
  // 60	AssignmentEditor
  // 61	OfficeGoal
  // 62	ExportQueue
  // 64	EvaluatorFraudGroup
  // 65	UserGoal
  // 66	ServiceFee
  // 67	CreditMemoRequest
  // 68	LineItemCreditRequest
  // 69	ReleaseNote
  // 71	OfficeOverhead
  // 72	Tax
  // 10003	Lookup
  // 10004	LookupItem
  // 10005	FreelancerUser
  // 10006	FreelancerFee
  // 10007	FreelancerLineItem
  // 10008	FreelancerPaymentExport

  static defaultProps = {
    entityTypeId: 8, //Default Entity: Lead
    entityId: 13, //Lead table : TNS - MCP Global Center
    enableAddNew: true,
  };

  constructor(props) {
    super(props);
    this.state = {
      attachmentList: [],
      loading: true,
      selectedAttachmentId: -1,
      window: null,
      isOverWindow: true,
    };
    this.clickOnAddNewAttachment = this.clickOnAddNewAttachment.bind(this);
  }

  componentDidMount() {
    this.populateAttachmentListData();
  }

  async populateAttachmentListData() {
    this.setState({ loading: true });
    AttachmentService.GetAttachmentByEntityTypeIdAndEntityId(this.props.entityTypeId, this.props.entityId)
      .then((result) => {
        this.setState({
          attachmentList: result,
          loading: false,
        });
      })
      .catch((error) => {
        ErrorMessage.SetErrorMessage('AC108');
        this.setState({ loading: false });
      });
  }

  downloadAttachedFile(item) {
    this.setState({ loading: true });
    AttachmentService.DownloadAttachmentFile(item.attachmentId)
      .then((result) => {
        this.setState({
          loading: false,
        });

        fileHelper.saveBase64File(result, item.fileName, item.contentType);
      })
      .catch((error) => {
        ErrorMessage.SetErrorMessage('AC144');
        this.setState({ loading: false });
      });
  }

  // Deleting is for administrators only, permanent, and confirmed first. The server refuses the file of a payment
  // export and leaves a comment naming the attachment on the record it belonged to.
  clickOnDeleteAttachment(item) {
    ErrorMessage.SetApprove(`Delete the attachment "${item.fileName}" permanently? This cannot be undone.`, () =>
      this.deleteAttachment(item)
    );
  }

  deleteAttachment(item) {
    this.setState({ loading: true });
    AttachmentService.DeleteAttachment(item.attachmentId)
      .then((result) => {
        if (result?.error) {
          ErrorMessage.SetErrorMessage(result.error);
          this.setState({ loading: false });
          return;
        }
        ErrorMessage.SetSuccessMessage('The attachment has been deleted.');
        this.populateAttachmentListData();
      })
      .catch(() => {
        ErrorMessage.SetErrorMessage('AC170');
        this.setState({ loading: false });
      });
  }

  renderAddButtonRow() {
    if (!this.props.enableAddNew) {
      return null;
    }
    return (
      <FigmaButtonRow
        className='panel-corner-actions'
        buttons={[
          {
            iconName: this.props.icon || 'fa-solid fa-plus-circle',
            type: ButtonTypeEnum.NormalIconOnly,
            color: ButtonColorsEnum.Primary,
            iconPosition: IconPositionEnum.Center,
            onClick: this.clickOnAddNewAttachment,
            tooltip: 'Add New Attachment',
          },
        ]}
      />
    );
  }

  renderDeleteButton(attachment) {
    return (
      <FigmaButton
        iconName='fa-solid fa-trash-can'
        type={ButtonTypeEnum.NormalIconOnly}
        color={ButtonColorsEnum.Destruct}
        iconPosition={IconPositionEnum.Center}
        tooltip='Delete attachment'
        onClick={() => this.clickOnDeleteAttachment(attachment)}
      />
    );
  }

  renderAttachmentList() {
    const canDelete = AuthService.IsAdmin();
    return (
      <div className='att-card'>
        <div className='att-card-head'>
          <span>{'Attachments'}</span>
          {this.renderAddButtonRow()}
        </div>
        <table className='att-table'>
          <thead>
            <tr>
              <th className='att-num'>{'Id'}</th>
              <th>{'Created By'}</th>
              <th>{'File'}</th>
              <th className='att-num'>{'FileSize'}</th>
              <th>{'Description'}</th>
              {canDelete && <th />}
            </tr>
          </thead>
          <tbody>
            {this.state.attachmentList.length === 0 && (
              <tr>
                <td
                  className='att-empty'
                  colSpan={canDelete ? 6 : 5}
                >
                  {'No attachments yet'}
                </td>
              </tr>
            )}
            {this.state.attachmentList.map((attachment, index) => (
              <tr key={`att${index}`}>
                <td className='att-num att-id'>{attachment.attachmentId}</td>
                <td>{attachment.createdByUserName}</td>
                <td>
                  <span
                    className='att-filelink'
                    onClick={() => this.downloadAttachedFile(attachment)}
                  >
                    {attachment.fileName}
                  </span>
                </td>
                <td className='att-num'>{attachment.fileSizeKB} kB</td>
                <td className='att-desc'>{attachment.description}</td>
                {canDelete && <td>{this.renderDeleteButton(attachment)}</td>}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  clickOnAddNewAttachment() {
    const addNewWindow = (
      <AddNewAttachmentWindow
        clickOnCancel={(refresh) => {
          this.setState({ window: null });
          if (refresh) {
            this.populateAttachmentListData();
          }
        }}
        entityTypeId={this.props.entityTypeId}
        entityId={this.props.entityId}
        isOverWindow={this.props.isOverWindow}
      />
    );
    this.setState({ window: addNewWindow });
  }

  render() {
    return (
      <div
        className={`attachments-panel ${
          this.props.isOverwindow ? 'verticalScroll panel-max-height' : 'verticalScroll'
        }`}
      >
        <Loading loading={this.state.loading} />
        {!this.state.loading && this.renderAttachmentList()}
        {this.props.enableAddNew && this.state.window}
      </div>
    );
  }
}

export default AttachmentsComponent;
